
/**
 * Wait for X milliseconds 
 * @param {*} milliseconds 
 * @returns 
 */
export async function sleep(milliseconds) {
  return new Promise((resolve) => setTimeout(resolve, milliseconds));
}


export function BigIntsToStr(obj) {
  for (const [key, value] of Object.entries(obj)) {
    if (typeof value === 'bigint')
      obj[key] = value.toString();
  }
}